import HouseIcon from './component.jsx'
export default HouseIcon
